import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as actions from './redux/actions'
import { checkPermission } from 'common/hooks/useCheckPermission'
import { Card, HeroBanner, AssistantBanner, PermissionsNotice } from './inicio-ui'

export class Inicio extends Component {
    static propTypes = {
        home: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired
    }

    hasAnyPermission = checkPermission('HAS_ANY', this.props.permissions)

    render() {
        return (
            <div className={`home-inicio ${!this.hasAnyPermission ? 'without-permission' : ''}`}>
                <div className="home-inicio__cards">
                    <Card variant="hero">
                        <HeroBanner />
                    </Card>
                    <Card variant="assistant">
                        <AssistantBanner />
                    </Card>
                    {!this.hasAnyPermission && <PermissionsNotice />}
                </div>
            </div>
        )
    }
}

/* istanbul ignore next */
function mapStateToProps(state) {
    return {
        home: state.home,
        permissions: state.common.user.permissions
    }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...actions }, dispatch)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Inicio)
